// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_bambu_vase_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_bambu_vase_shade: ModuleSchema = {
  "id": "core_bambu_vase_shade",
  "uniqueId": "B3D_4FBDL",
  "createdAt": "2026-10-02T09:01:35.790Z",
  "updatedAt": "2026-10-30T10:31:13.341Z",
  "label": "Bambu Vase Shade",
  "description": "core_bambu_vase_shade parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_BAMBU_VASE"
  ],
  "sliders": [
    {
      "key": "shadeH",
      "label": "Vase Height",
      "min": 80,
      "max": 260,
      "step": 2,
      "default": 160,
      "unit": "mm"
    },
    {
      "key": "shadeBotDia",
      "label": "Base Diameter (Ø)",
      "min": 70,
      "max": 160,
      "step": 1,
      "default": 90,
      "unit": "mm"
    },
    {
      "key": "shadeBellyDia",
      "label": "Belly Bulge Diameter (Ø)",
      "min": 80,
      "max": 200,
      "step": 1,
      "default": 135,
      "unit": "mm"
    },
    {
      "key": "shadeTopDia",
      "label": "Top Mouth Diameter (Ø)",
      "min": 50,
      "max": 160,
      "step": 1,
      "default": 80,
      "unit": "mm"
    },
    {
      "key": "bellyPos",
      "label": "Belly Bulge Position",
      "min": 0.25,
      "max": 0.55,
      "step": 0.01,
      "default": 0.38
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "vase_shade",
      "label": "Bambu Vase Body (45 Layers / 9mm Thread)",
      "default": "#f8fafc",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "bambu_vase_shade_obj",
      "label": "Bambu LED Kit Vase Lampshade",
      "name": "Bambu LED Kit Vase Lampshade",
      "color": "#f8fafc",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "vase_shade",
          "label": "Bambu Vase Body (45 Layers / 9mm Thread)",
          "name": "Bambu Vase Body (45 Layers / 9mm Thread)",
          "groupId": 0,
          "colorKey": "vase_shade",
          "defaultColor": "#f8fafc",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
